import { render, staticRenderFns } from "./FilterMenuGroup.vue?vue&type=template&id=2fdb7818&scoped=true&"
import script from "./FilterMenuGroup.vue?vue&type=script&lang=js&"
export * from "./FilterMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./FilterMenuGroup.vue?vue&type=style&index=0&id=2fdb7818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb7818",
  null
  
)

export default component.exports